// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rj-6";
export var imgContainer = "_rj-3";
export var menuIcon = "_rj-5";
export var pillWrapper = "_rj-2";
export var pillsContainer = "_rj-1";
export var subscriptionCard = "_rj-0";
export var subscriptionLogo = "_rj-4";